import React, {Component} from 'react';
import {intlShape} from 'react-intl';

import './ApproveMessage.less';
import NotificationBanner, {BANNER_STYLE, NOTIFICATION_TYPE} from '../../../shared-components/NotificationBanner/NotificationBanner';

const LOCALE_PREFIX = 'DE/pages/TermsPage/TermsPage';

export class ApproveMessage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const { intl } = this.props;

        return (
            <NotificationBanner
                bannerStyle={BANNER_STYLE.LIGHT_BG}
                className="approveMessage"
                condensed
                message={intl.formatMessage({ id: `${LOCALE_PREFIX}.approvedHeader`})}
                type={NOTIFICATION_TYPE.SUCCESS}
                useVX
            />
        );
    }
}


export default ApproveMessage;
